import React, { Fragment, useContext, useEffect, useImperativeHandle, useState } from 'react';

import {
    customHeaderStyle, defaultPaginationOptions,
    defaultTableHeaderStyles,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle, TableActionIconGeneric
} from "root/Tables/BaseTableComponents";
import PassportTable, { xlateBootstrapTableColumns } from "root/Tables/PassportTable";

import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import { runReport } from "root/Tables/ProviderReportHelper";
import GlobalContext, { useGlobalContext } from "root/Contexts/GlobalContext";
import { ConfigOptions } from "root/Contexts/GlobalProvider";

const TableProviderSurveys = ( {data, survey_type} ) =>
{
    const { getCustomObject } = useGlobalContext() ;
    const pdfParams = getCustomObject ( ConfigOptions.PDF_PARAMETERS )

    const pdfFormatter = ( cell, row ) =>
    {
        const yr = row.academic_year;
        return (
            <Fragment>
                <TableActionIconGeneric
                    onClick={ () => runReport ( row.provider_id, row.provider_name, yr, survey_type, false, pdfParams ) }
                    style={ { paddingLeft: '8px' } } icon='bi bi-filetype-pdf'
                    text={ 'View ' + yr + ' ACTIONS PDF Report' }/>
                <TableActionIconGeneric
                    onClick={ () => runReport ( row.provider_id, row.provider_name, yr, survey_type, true, pdfParams ) }
                    style={ { paddingLeft: '8px' } } icon='bi bi-filetype-pdf'
                    text={ 'View ' + yr + ' FULL PDF Report' }/>
            </Fragment>
        )
    }

    const headerStyle = customHeaderStyle.bind ( null, {
        default: { ...defaultTableHeaderStyles, fontSize: '16px' },
        establishment_number: { borderRadius: defaultTopLeftCellStyle, width: "10vw" },
        provider_name: { width: "20vw" },
        establishment_type_name: { width: "15vw" },
        academic_year: { width: "6vw" },
        actions: { borderRadius: defaultTopRightCellStyle, width: "5vw" }
    } );

    const getColumns = () =>
    {
        let columns = [];

        columns.push ( {
            dataField: 'establishment_number',
            text: 'Establishment Number',
            sort: true,
            headerStyle: headerStyle
        } );

        columns.push ( {
            dataField: 'provider_name',
            text: 'School Name',
            sort: true,
            headerStyle: headerStyle
        } );

        columns.push ( {
            dataField: 'establishment_type_name',
            text: 'Type',
            sort: true,
            headerStyle: headerStyle
        } );
        columns.push ( {
            dataField: 'academic_year',
            text: 'Year',
            sort: true,
            headerStyle: headerStyle
        } );
        columns.push ( {
            dataField: 'actions',
            text: 'View PDFs',
            formatter: pdfFormatter,
            headerStyle: headerStyle
        } );

        return columns;
    }

    const translations = xlateBootstrapTableColumns ( getColumns () );

    const columns = React.useMemo ( () => translations, [] );

    const tableContent = () =>
    {
        return <PassportTable data={ data.data } isLoading={ data.loading } columns={ columns }
                              pagination={ defaultPaginationOptions } showSearch={ true }/>
    }

    return data.loading === true ? <SpinnerDiv/> : tableContent ();
}

export default TableProviderSurveys;
